export const LOAN_LIST_REQUEST = 'LOAN_LIST_REQUEST';
export const LOAN_LIST_REQUEST_SUCCESS = 'LOAN_LIST_REQUEST_SUCCESS';
export const LOAN_LIST_REQUEST_ERROR = 'LOAN_LIST_REQUEST_ERROR';
export const LOAN_REQUEST = 'LOAN_REQUEST';
export const LOAN_REQUEST_SUCCESS = 'LOAN_REQUEST_SUCCESS';
export const LOAN_REQUEST_ERROR = 'LOAN_REQUEST_ERROR';
export const LOAN_REPAYMENT_REQUEST = 'LOAN_REPAYMENT_REQUEST';
export const LOAN_REPAYMENT_REQUEST_SUCCESS = 'LOAN_REPAYMENT_REQUEST_SUCCESS';
export const LOAN_REPAYMENT_REQUEST_ERROR = 'LOAN_REPAYMENT_REQUEST_ERROR';
export const LENDING_REQUEST = 'LENDING_REQUEST';
export const LENDING_REQUEST_SUCCESS = 'LENDING_REQUEST_SUCCESS';
export const LENDING_REQUEST_ERROR = 'LENDING_REQUEST_ERROR';
export const SEND_SMS_REQUEST = 'SEND_SMS_REQUEST';
export const SEND_SMS_REQUEST_SUCCESS = 'SEND_SMS_REQUEST_SUCCESS';
export const SEND_SMS_REQUEST_ERROR = 'SEND_SMS_REQUEST_ERROR';
export const DOWNLOAD_LOAN_NOTICE_REQUEST = 'DOWNLOAD_LOAN_NOTICE_REQUEST';
export const DOWNLOAD_LOAN_NOTICE_REQUEST_SUCCESS = 'DOWNLOAD_LOAN_NOTICE_REQUEST_SUCCESS';
export const DOWNLOAD_LOAN_NOTICE_REQUEST_ERROR = 'DOWNLOAD_LOAN_NOTICE_REQUEST_ERROR';
